import bills from './bills'
import campaigns from './campaigns'
import clients from './clients'
import comments from './comments'
import communications from './communications'
import companies from './companies'
import discounts from './discounts'
import employees from './employees'
import estimates from './estimates'
import feedback from './feedback'
import files from './files'
import history from './history'
import homemart from './homemart'
import inspectionCompanies from './inspection-companies'
import inspectionRequests from './inspection-requests'
import inspectors from './inspectors'
import insurances from './insurances'
import invitations from './invitations'
import invoices from './invoices'
import items from './items'
import jobs from './jobs'
import licenses from './licenses'
import matches from './matches'
import materialInvoices from './materialInvoices'
import materials from './materials'
import notes from './notes'
import notifications from './notifications'
import orders from './orders'
import payments from './payments'
import pcView from './pc-view'
import promoCodes from './promoCodes'
import repairList from './repairlist'
import reports from './reports'
import searches from './searches'
import siteVisits from './siteVisits'
import subscriptions from './subscriptions'
import territories from './territories'
import tradeTypes from './trades'
import users from './users'
import vendors from './vendors'
import widgets from './widgets'
import workOrders from './work-orders'
import workflows from './workflows'
import contractors from './contractors'

const punchlist = {
  bills,
  clients,
  files,
  orders,
  employees,
  vendors,
  searches,
  siteVisits,
  users,
  territories,
  jobs,
  licenses,
  companies,
  history,
  items,
  workflows,
  notifications,
  comments,
  feedback,
  notes,
  invitations,
  invoices,
  payments,
  tradeTypes,
  communications,
  materialInvoices,
  estimates,
  subscriptions,
  insurances,
  widgets,
  matches,
  repairList,
  materials,
  reports,
  homemart,
  discounts,
  campaigns,
  workOrders,
  pcView,
  inspectionCompanies,
  inspectors,
  promoCodes,
  inspectionRequests,
  contractors
}

export default punchlist
